import { Box, Typography, useTheme } from "@mui/material";
import { NavLink } from "react-router-dom";
import BugReportIcon from "@mui/icons-material/BugReport";
import { tokens } from "../../theme/theme";

export const SidebarMenuItem = ({ item, Icon = BugReportIcon, open }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  return (
    <NavLink to={item.to} target={item.target}>
      <Box
        className="pl-2 flex flex-row gap-2 justify-start items-center py-1"
        sx={{
          ":hover": {
            cursor: "pointer",
            "& svg": {
              color: colors.greenAccent[500],
            },
          },
        }}
      >
        <Icon sx={{ color: colors.contrast[600] }} />
        <Typography>{item.label}</Typography>
      </Box>
    </NavLink>
  );
};
